var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"root",on:{"wheel":_vm.handleWheel,"mousedown":_vm.startDrag}},[_c('div',{staticClass:"map",style:(_vm.style)},[(_vm.coordinate)?_vm._t("default"):_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }